function toggleSummaryBullets() {
    var bullets = document.querySelector('.ProductMeta__SummaryBullets'),
        button = document.querySelector('.ProductMeta__ReadMore');

    if(bullets){
        if (bullets.querySelectorAll('li').length > 3) {
            var moreText = button.innerText,
                lessText = button.dataset.lessText;

            button.addEventListener('click', function() {
                this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true' );
                this.innerText = this.getAttribute('aria-expanded') === 'true' ? lessText : moreText;
                bullets.classList.toggle('ProductMeta__SummaryBullets--all');
            });
        } else {
            button.style.display = 'none';
        }
    }

}

function toggleVariantThumbnails() {
    document.addEventListener('variant:changed', function(event) {
        syncVariantMedia(event.detail.variant);
    });
}

function syncInitialVariantMedia() {
    const productJson = document.querySelector('[data-product-json]');

    if (!productJson) {
        return;
    }

    const productData = JSON.parse(productJson.innerHTML);
    const selectedVariant = productData.product.variants.find(function(variant) {
        return variant.id === productData.selected_variant_id;
    });

    syncVariantMedia(selectedVariant);
}

function syncVariantMedia(variant) {
    const productElement = document.querySelector('.Product');

    if (!variant || !productElement) {
        return;
    }

    const targetOption = productElement.dataset.changeImageOption;

    if (!(targetOption in variant)) {
        return;
    }

    const colorName = normalizeColorValue(variant[targetOption]);
    const thumbs = Array.prototype.slice.call(document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage'));
    const dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
    const hasThumb = thumbs.some(function(thumb) {
        return colorName === normalizeColorValue(thumb.dataset.color);
    });

    if (hasThumb) {
        thumbs.forEach( function(thumb) {
            if (colorName === normalizeColorValue(thumb.dataset.color)) {
                thumb.classList.remove('hidden-tablet-and-up');
            } else {
                thumb.classList.add('hidden-tablet-and-up');
            }
        });
        toggleVariantDots(colorName);
    } else {
        thumbs.forEach( function(thumb) {
            thumb.classList.remove('hidden-tablet-and-up');
        });
        dots.forEach( function(dot) {
            dot.classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
        });
    }

    selectVariantMedia(variant, colorName);
}

function selectVariantMedia(variant, selectedColor) {
    const targetSlide = findVariantSlide(variant, selectedColor);

    if (!targetSlide) {
        return;
    }

    const slideshow = document.querySelector('.Product__Slideshow');
    const flickity = window.Flickity && slideshow ? Flickity.data(slideshow) : null;

    if (flickity) {
        const slides = Array.prototype.slice.call(slideshow.querySelectorAll('.Product__SlideItem'));
        const slideIndex = slides.indexOf(targetSlide);

        if (slideIndex > -1) {
            flickity.select(slideIndex);
        }
    }

    const mediaId = targetSlide.dataset.mediaId;
    const navLink = document.querySelector('.Product__SlideshowNavImage[data-media-id="' + mediaId + '"]');

    if (navLink) {
        navLink.click();
    }
}

function findVariantSlide(variant, selectedColor) {
    const mediaId = getVariantMediaId(variant);
    let targetSlide = mediaId ? document.querySelector('.Product__SlideItem[data-media-id="' + mediaId + '"]') : null;

    if (!targetSlide && variant.featured_image && variant.featured_image.src) {
        const imageFilename = getImageFilename(variant.featured_image.src);

        Array.prototype.slice.call(document.querySelectorAll('.Product__SlideItem[data-media-type="image"]')).some(function(slide) {
            const image = slide.querySelector('[data-original-src]');

            if (image && getImageFilename(image.dataset.originalSrc) === imageFilename) {
                targetSlide = slide;
                return true;
            }

            return false;
        });
    }

    if (!targetSlide && selectedColor) {
        const navLink = document.querySelector('.Product__SlideshowNavImage[data-color="' + selectedColor + '"]');
        const navMediaId = navLink ? navLink.dataset.mediaId : null;

        targetSlide = navMediaId ? document.querySelector('.Product__SlideItem[data-media-id="' + navMediaId + '"]') : null;
    }

    return targetSlide;
}

function getVariantMediaId(variant) {
    if (variant.featured_media && variant.featured_media.id) {
        return variant.featured_media.id;
    }

    if (variant.featured_image && variant.featured_image.id) {
        return variant.featured_image.id;
    }

    return null;
}

function getImageFilename(src) {
    return src ? src.split('?')[0].split('/').pop() : '';
}

function normalizeColorValue(value) {
    return value ? value.replace(/[\s\/\-_]+/g, '').toLowerCase() : '';
}

function toggleVariantDots(selectedColor) {
    const productSlideshow = Flickity.data('.Product__Slideshow');
    if (productSlideshow) {
        const thumbs = document.querySelectorAll('.Product__SlideshowNavImage');
        const dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
        thumbs.forEach( function(thumb,i) {
            dots[i].dataset.color = thumb.dataset.color;
            if(selectedColor === normalizeColorValue(thumb.dataset.color)) {
                dots[i].classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
            } else {
                dots[i].classList.add('hidden-phone','hidden-tablet', 'hidden-lap');
            }
        });
    }
}

function initPDPBullets() {
    var bulets_wrapper = document.querySelectorAll('.summary-bullets');
    var bulets = document.querySelectorAll('.summary-bullets ul li');
    if(bulets.length){
        var x = document.createElement("button");
        x.setAttribute("data-status", 0);
        var t = document.createTextNode("Read More");    // Create a text node
        x.appendChild(t);
        bulets_wrapper[0].appendChild(x);
        x.addEventListener('click', function() {
            let status =  x.getAttribute("data-status");

            if(parseInt(status)===0){
                x.textContent = "Read Less";
                for( const bulet of bulets ) {
                    bulet.style.display = "list-item";

                }
                x.setAttribute("data-status", 1);
            } else {
                x.textContent = "Read More";
                x.setAttribute("data-status", 0);
                let p = 1;
                for( const bulet of bulets ) {
                    if(p>3){
                        bulet.style.display = "none";
                    }
                    p++;
                }
            }

        });
    }
    let i = 1;
    for( const bulet of bulets ) {
        if(i>3){
            bulet.style.display = "none";
        }

        i++;
    }
}

(function () {
  const theToggle = document.getElementById('the_toggle');
  const theText = document.getElementById('the_text');

  // If we have 10 lines or more then display a view more button
  function initOveriewViewMore() {
    var divHeight = theText.offsetHeight;
    var lineHeight = parseInt(window.getComputedStyle(theText).getPropertyValue('line-height'));

    var lineCount = divHeight / lineHeight;
    if (lineCount < 10) {
        theToggle.style.display = 'none';
    }
  }

  function handleClick() {
    event.preventDefault();
    if (theText.classList.contains("clamped_text")) {
      theToggle.textContent = "Read Less";
      theText.classList.remove("clamped_text");
      theText.classList.add("expanded_text");
    } else {
      theToggle.textContent = "Read More";
      theText.classList.remove("expanded_text");
      theText.classList.add("clamped_text");
    }
  }

  initOveriewViewMore();
  theToggle.addEventListener('click', handleClick);
})();

(function () {
  const theToggle = document.getElementById('compare_toggle');
  const toggleText = document.getElementById('compare_toggle_text');
  const theIcon = document.getElementById('compare-arrow');
  const theText = document.getElementById('compare_table');

  function handleClick() {
    event.preventDefault();
    if (theText.classList.contains("clamped_text")) {
      toggleText.innerHTML = "View Less &nbsp;";
      theText.classList.remove("clamped_text");
      theText.classList.add("expanded_text");
      theIcon.style.transform = 'rotate(180deg)';
    } else {
      toggleText.innerHTML = "View More &nbsp;";
      theText.classList.remove("expanded_text");
      theText.classList.add("clamped_text");
      theIcon.style.transform = 'rotate(0deg)';
    }
  }

  if (theToggle) {
    theToggle.addEventListener('click', handleClick);
  }
})();

(function () {
  const theToggle = document.querySelector('#included_toggle');
  const theIcon = document.querySelector('#included-arrow');

  function handleClick() {
    event.preventDefault();
    if (theToggle.classList.contains("included-closed")) {
      theToggle.classList.remove("included-closed");
      theToggle.classList.add("included-open");
      theIcon.style.transform = 'rotate(180deg)';
    } else {
      theToggle.classList.remove("included-open");
      theToggle.classList.add("included-closed");
      theIcon.style.transform = 'rotate(0deg)';
    }
  }

  if (theToggle) {
    theToggle.addEventListener('click', handleClick);
  }
})();

document.addEventListener('DOMContentLoaded', function() {
    toggleSummaryBullets();
    toggleVariantThumbnails();
    syncInitialVariantMedia();
    initPDPBullets();


});